import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [emailError, setEmailError] = useState('')
  const { login } = useAuth()
  const navigate = useNavigate()

  const validateEmail = (value) => {
    if (value && !/\S+@\S+\.\S+/.test(value)) {
      setEmailError('Formato de correo invalido')
    } else {
      setEmailError('')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
      navigate('/')
    } catch (err) {
      setError(err.message || 'Credenciales invalidas. Intenta de nuevo.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      {/* Fondo de pantalla */}
      <div className="login-bg" />
      <div className="login-overlay" />

      {/* Tarjeta de login */}
      <div className="login-card">
        <div className="card-header">
          <div className="brand">Rutas de Solidaridad</div>
          <h1 className="card-title">Bienvenido de nuevo</h1>
          <p className="card-subtitle">Ingresa tus credenciales para continuar</p>
        </div>

      {/* Modal de error */}
      {error && (
        <div className="modal-error-overlay" onClick={() => setError('')}>
          <div className="modal-error-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-error-header">
              <div className="modal-error-icon">
                <svg width="24" height="24" viewBox="0 0 20 20" fill="#DC2626">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <h3>Error al iniciar sesion</h3>
              <button className="modal-error-close" onClick={() => setError('')}>&times;</button>
            </div>
            <div className="modal-error-body">
              <p>{error}</p>
            </div>
            <div className="modal-error-footer">
              <button className="modal-error-btn" onClick={() => setError('')}>Entendido</button>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="card-form">

          <div className="form-group">
            <label className="form-label">Correo electronico</label>
            <input
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => { setEmail(e.target.value); validateEmail(e.target.value) }}
              onBlur={() => validateEmail(email)}
              required
              className={`form-input ${emailError ? 'input-error' : ''}`}
            />
            {emailError && <span className="field-error">{emailError}</span>}
          </div>

          <div className="form-group">
            <label className="form-label">Contrasena</label>
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Ingresa tu contrasena"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
                minLength={6}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Ocultar contrasena' : 'Mostrar contrasena'}
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input type="checkbox" className="checkbox" defaultChecked />
              <span>Recordarme</span>
            </label>
            <a href="#" className="forgot-link" onClick={(e) => e.preventDefault()}>Olvidaste tu contrasena?</a>
          </div>

          <button type="submit" disabled={loading} className="login-btn">
            {loading ? (
              <span className="btn-loading">
                <svg className="btn-spinner" viewBox="0 0 20 20">
                  <circle cx="10" cy="10" r="8" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2" />
                  <circle cx="10" cy="10" r="8" fill="none" stroke="white" strokeWidth="2" strokeDasharray="50" strokeDashoffset="35" />
                </svg>
                Iniciando sesion...
              </span>
            ) : (
              'Iniciar Sesion'
            )}
          </button>
        </form>

        <div className="card-footer">
          <p>No tienes cuenta? <a href="#" onClick={(e) => e.preventDefault()} className="register-link">Registrate</a></p>
        </div>
      </div>

      <style>{`
        .login-page {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          overflow: hidden;
        }

        .login-bg {
          position: fixed;
          inset: 0;
          background-image: url('https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?w=1600&q=80');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 0;
          animation: zoomBg 20s ease-in-out infinite alternate;
        }

        @keyframes zoomBg {
          from { transform: scale(1); }
          to { transform: scale(1.05); }
        }

        .login-overlay {
          position: fixed;
          inset: 0;
          background: linear-gradient(135deg, rgba(15,23,42,0.6) 0%, rgba(30,64,175,0.4) 50%, rgba(15,23,42,0.5) 100%);
          z-index: 1;
        }

        .login-card {
          position: relative;
          z-index: 2;
          width: 100%;
          max-width: 420px;
          background: rgba(255,255,255,0.97);
          border-radius: 20px;
          box-shadow: 0 25px 60px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.08);
          padding: 40px 36px 32px;
          backdrop-filter: blur(2px);
          animation: fadeUp 0.6s ease;
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .card-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .brand {
          font-size: 0.75rem;
          font-weight: 600;
          color: #1E40AF;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 16px;
        }

        .card-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1F2937;
          margin-bottom: 6px;
          letter-spacing: -0.01em;
        }

        .card-subtitle {
          font-size: 0.88rem;
          color: #6B7280;
        }

        .card-form {
          display: flex;
          flex-direction: column;
          gap: 0;
        }

        .form-alert {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          background: #FEF2F2;
          border: 1px solid #FECACA;
          border-radius: 10px;
          margin-bottom: 20px;
          font-size: 0.82rem;
          color: #991B1B;
        }

        .form-group {
          margin-bottom: 18px;
        }

        .form-label {
          display: block;
          font-size: 0.82rem;
          font-weight: 600;
          color: #374151;
          margin-bottom: 6px;
        }

        .form-input {
          width: 100%;
          padding: 12px 14px;
          border: 1.5px solid #E5E7EB;
          border-radius: 10px;
          font-size: 0.92rem;
          font-family: 'Inter', sans-serif;
          color: #1F2937;
          background: #F9FAFB;
          outline: none;
          transition: all 0.2s ease;
          box-sizing: border-box;
        }

        .form-input:focus {
          border-color: #1E40AF;
          background: #FFFFFF;
          box-shadow: 0 0 0 3px rgba(30,64,175,0.1);
        }

        .form-input::placeholder {
          color: #9CA3AF;
        }

        .form-input.input-error {
          border-color: #EF4444;
          background: #FEF2F2;
        }

        .field-error {
          display: block;
          font-size: 0.75rem;
          color: #EF4444;
          margin-top: 4px;
        }

        .password-field {
          position: relative;
        }

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.6;
          transition: opacity 0.2s;
        }

        .password-toggle:hover {
          opacity: 1;
        }

        .form-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.85rem;
          color: #6B7280;
          cursor: pointer;
        }

        .checkbox {
          width: 16px;
          height: 16px;
          accent-color: #1E40AF;
          cursor: pointer;
        }

        .forgot-link {
          font-size: 0.82rem;
          color: #1E40AF;
          text-decoration: none;
          font-weight: 500;
        }

        .forgot-link:hover {
          text-decoration: underline;
        }

        .login-btn {
          width: 100%;
          padding: 13px;
          background: #1E40AF;
          color: #FFFFFF;
          border: none;
          border-radius: 10px;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          font-family: 'Inter', sans-serif;
          min-height: 48px;
        }

        .login-btn:hover:not(:disabled) {
          background: #1E3A8A;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(30,64,175,0.25);
        }

        .login-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .btn-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .btn-spinner {
          width: 18px;
          height: 18px;
          animation: spinBtn 0.8s linear infinite;
        }

        .btn-spinner circle:last-child {
          stroke-dasharray: 45;
          stroke-dashoffset: 30;
          animation: dash 1.5s ease-in-out infinite;
        }

        @keyframes spinBtn {
          to { transform: rotate(360deg); }
        }

        @keyframes dash {
          0% { stroke-dashoffset: 45; }
          50% { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: -45; }
        }

        .card-footer {
          text-align: center;
          margin-top: 28px;
          padding-top: 20px;
          border-top: 1px solid #F3F4F6;
        }

        .card-footer p {
          font-size: 0.85rem;
          color: #6B7280;
        }

        .register-link {
          color: #1E40AF;
          font-weight: 600;
          text-decoration: none;
        }

        .register-link:hover {
          text-decoration: underline;
        }

        @media (max-width: 480px) {
          .login-card {
            padding: 28px 20px 24px;
            border-radius: 16px;
            margin: 10px;
          }

          .card-title {
            font-size: 1.3rem;
          }

          .form-input {
            padding: 14px;
            font-size: 16px;
          }

          .login-btn {
            padding: 15px;
            min-height: 50px;
            font-size: 1rem;
          }

          .card-header {
            margin-bottom: 24px;
          }

          .form-options {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }
        }

        @media (max-width: 360px) {
          .login-card {
            padding: 20px 16px 20px;
          }
        }

        .modal-error-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
          animation: fadeIn 0.2s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-error-card {
          background: white;
          border-radius: 16px;
          width: 100%;
          max-width: 380px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.25);
          animation: slideUp 0.3s ease;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }

        .modal-error-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 20px 24px 0;
        }

        .modal-error-header h3 {
          flex: 1;
          font-size: 1rem;
          font-weight: 700;
          color: #1F2937;
          margin: 0;
        }

        .modal-error-icon {
          flex-shrink: 0;
          display: flex;
        }

        .modal-error-close {
          background: none;
          border: none;
          font-size: 1.5rem;
          color: #9CA3AF;
          cursor: pointer;
          padding: 0 4px;
          line-height: 1;
        }

        .modal-error-close:hover {
          color: #4B5563;
        }

        .modal-error-body {
          padding: 12px 24px 20px;
        }

        .modal-error-body p {
          font-size: 0.88rem;
          color: #6B7280;
          margin: 0;
          line-height: 1.5;
        }

        .modal-error-footer {
          padding: 0 24px 20px;
        }

        .modal-error-btn {
          width: 100%;
          padding: 11px;
          background: #1E40AF;
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
          transition: background 0.2s;
        }

        .modal-error-btn:hover {
          background: #1E3A8A;
        }

        @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
          .login-card {
            background: rgba(255,255,255,0.92);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
          }
        }
      `}</style>
    </div>
  )
}

export default Login